module.exports = __webpack_public_path__ + "img/carshinaused_01.1064fdfa.jpg";